<template>
<nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <a href="https://gbwaap.com/" title="GBWhatsApp" rel="home">
          <img class="header-image is-logo-image" alt="GBWhatsApp" src="../assets/logo.webp" title="GBWhatsApp">
        </a>
      </div>
      <p class="main-title" itemprop="headline">
        <a href="https://gbwaap.com/" rel="home">
          GB Wa App
        </a>
      </p>
    </div>
    <ul id="menu-primary-menu-mobile" class="menu sf-menu mobile-menu-page" v-show="isMenuClicked">
      <li class="menu-item">
        <router-link :to="homePath">{{ navLabels.home }}</router-link>
      </li>
      <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="https://gbwaap.com/download/" >{{ navLabels.download }}</a>
      </li>
      <li id="menu-item-34" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
        <a href="https://gbwaap.com/blog/">{{ navLabels.blogs }}</a>
      </li>
      <li class="menu-item mods-switcher-mobile">
        <div class="mods-current" @click="isModClicked = !isModClicked">
          <span>{{ navLabels.mod }}</span>
        </div>
        <ul class="mods-dropdown" v-show="isModClicked">
          <li v-for="item in modLinks" :key="item.path">
            <router-link :to="item.path" @click.native="isMenuClicked = false">{{ item.label }}</router-link>
          </li>
        </ul>
      </li>
      <!-- Mobile Language Switcher -->
      <li class="menu-item lang-switcher-mobile">
        <div class="lang-current" @click="isLangOpen = !isLangOpen">
          <span>{{ currentLangFlag }} {{ currentLangName }}</span>
        </div>
        <ul class="lang-dropdown" v-show="isLangOpen">
          <li v-for="item in lang" :key="item.lang">
            <a href="javascript:void(0)" @click="switchLanguage(item.lang)">{{ item.val }}</a>
          </li>
        </ul>
      </li>
    </ul>

    <div id="primary-menu" class="main-nav">
      <!-- mobile -->
      <div class="mobile-menu" v-if="$ua.isMobileDevice">
        <div class="menu-toggle" @click="isMenuClicked=!isMenuClicked">
          <img src="@/assets/menu.svg" alt="menu button" v-if="!isMenuClicked">
          <img src="@/assets/xmark-black.svg" alt="close button" v-else>
        </div>
      </div>
      <!-- pc -->
      <ul v-else id="menu-primary-menu" class="menu sf-menu">
        <li class="menu-item">
          <router-link :to="homePath">{{ navLabels.home }}</router-link>
        </li>
        <li id="menu-item-33" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 header-download">
          <a href="https://gbwaap.com/download/">{{ navLabels.download }}</a>
        </li>
        <li id="menu-item-34" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33 header-download">
          <a href="https://gbwaap.com/blog/">{{ navLabels.blogs }}</a>
        </li>
        <li class="menu-item mods-switcher header-download">
          <div class="mods-current" @click="isModClicked = !isModClicked">
            <span>{{ navLabels.mod }}</span>
            <svg class="mods-arrow" :class="{open: isModClicked}" viewBox="0 0 24 24" width="12" height="12"><path fill="currentColor" d="M7 10l5 5 5-5z"/></svg>
          </div>
          <ul class="mods-dropdown" v-show="isModClicked">
            <li v-for="item in modLinks" :key="item.path">
              <router-link :to="item.path">{{ item.label }}</router-link>
            </li>
          </ul>
        </li>
        <!-- Language Switcher -->
        <li class="menu-item lang-switcher header-download">
          <div class="lang-current" @click="isLangOpen = !isLangOpen">
            <span>{{ currentLangFlag }} {{ currentLangName }}</span>
            <svg class="lang-arrow" :class="{open: isLangOpen}" viewBox="0 0 24 24" width="12" height="12"><path fill="currentColor" d="M7 10l5 5 5-5z"/></svg>
          </div>
          <ul class="lang-dropdown" v-show="isLangOpen">
            <li v-for="item in lang" :key="item.lang">
              <a href="javascript:void(0)" @click="switchLanguage(item.lang)">{{ item.val }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
import Search from './Search.vue';
export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
  },
  components: {
    Search,
  },
  data() {
    return {
      isHovered: false,
      isMenuClicked: false,
      isModClicked: false,
      isSearchClicked: false,
      isLangOpen: false,
      modLinks: [
        { label: 'FMWhatsApp', path: '/fmwhatsapp/' },
        { label: 'YoWhatsApp', path: '/yowhatsapp/' },
        { label: 'OGWhatsApp', path: '/ogwhatsapp/' },
        { label: 'JTWhatsApp', path: '/jtwhatsapp/' },
        { label: 'MBWhatsApp', path: '/mbwhatsapp/' },
        { label: 'WhatsApp Plus', path: '/whatsapp-plus/' },
        { label: 'Gold WhatsApp', path: '/gold-whatsapp/' },
        { label: 'Red WhatsApp', path: '/red-whatsapp/' },
        { label: 'Blue WhatsApp', path: '/blue-whatsapp/' },
      ],
      lang: [{
          lang: 'en',
          val: '🇺🇸 English'
        },
        {
          lang: 'id',
          val: '🇮🇩 Bahasa Indonesia'
        },
        {
          lang: 'pt',
          val: '🇵🇹 Português'
        },
        {
          lang: 'es',
          val: '🇪🇸 Español'
        },
        {
          lang: 'hi',
          val: '🇮🇳 हिंदी'
        },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          blogs: 'Blogs',
          mod: 'WhatsApp Mods',
        },
        ar: {
          home: 'الصفحة الرئيسية',
          download: 'تحميل',
          blogs: 'المدونات',
          mod: 'مودات واتس اب',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          blogs: 'Blog',
          mod: 'Mod WhatsApp',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
          mod: 'Mods do WhatsApp',
        },
        es: {
          home: 'Casa',
          download: 'Descargar',
          blogs: 'Blogs',
          mod: 'Mods de WhatsApp',
        },
        hi: {
          home: 'होम',
          download: 'डाउनलोड',
          blogs: 'ब्लॉग',
          mod: 'व्हाट्सएप मोड्स',
        },
      },
    }
  },
  computed: {
    homePath() {
      const paths = { en: '/', hi: '/in/', es: '/es/', pt: '/pt/', id: '/id/' };
      return paths[this.selectedLanguage] || '/';
    },
    currentLangFlag() {
      const flags = { en: '🇺🇸', hi: '🇮🇳', es: '🇪🇸', pt: '🇵🇹', id: '🇮🇩' };
      return flags[this.selectedLanguage] || '🇺🇸';
    },
    currentLangName() {
      const names = { en: 'English', hi: 'हिंदी', es: 'Español', pt: 'Português', id: 'Indonesia' };
      return names[this.selectedLanguage] || 'English';
    },
    navLabels() {
      return this.translation[this.selectedLanguage] || this.translation.en;
    },
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    }
  },
  methods: {
    switchLanguage(lang) {
      this.isLangOpen = false;
      const routes = {
        en: '/',
        hi: '/in/',
        es: '/es/',
        pt: '/pt/',
        id: '/id/',
      };
      const path = routes[lang] || '/';
      /* 站内切语言优先客户端路由，减少整页重载与白屏 */
      if (this.$router) {
        this.$router.push(path).catch(() => {});
      } else {
        window.location.assign(path);
      }
    },
    download() {
      if (typeof this.gotodownload === "function") {
        this.gotodownload();
      } else {
        console.error("gotodownload is not a function");
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/* 活力自然风格 Header；字体在页面级 link 加载 */

#site-navigation {
  position: sticky;
  top:0;
  z-index: 10000;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(247, 245, 240, 0.95) 100%);
  backdrop-filter: blur(20px);
  box-shadow: 0 2px 20px rgba(45, 90, 39, 0.08);
  border-bottom: 1px solid rgba(45, 90, 39, 0.06);

  .inside-navigation {
    width: 100%;
    max-width: 1080px;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
  }
}

.navigation-branding {
  display: flex;
  align-items: center;
  gap: 12px;

  .site-logo {
    img {
      height: 42px;
      width: auto;
      border-radius: 12px;
      transition: transform 0.3s ease;
      
      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .main-title {
    font-family: 'Outfit', sans-serif;
    font-size: 22px;
    font-weight: 700;
    margin: 0;
    
    a {
      color: #2d5a27;
      text-decoration: none;
      background: linear-gradient(135deg, #2d5a27 0%, #4a7c43 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      transition: all 0.3s ease;
      
      &:hover {
        opacity: 0.85;
      }
    }
  }
}

.main-nav {
  .menu {
    list-style-type: none !important;
    margin: 0 !important;
    display: flex;
    align-items: center;
    gap: 10px;

    li {
      display: flex;
      align-items: center;

      a {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 44px;
        min-height: 44px;
        box-sizing: border-box;
        font-family: 'DM Sans', sans-serif;
        font-weight: 500 !important;
        font-size: 15px;
        line-height: 1;
        padding: 0 20px;
        border-radius: 12px;
        transition: all 0.25s ease;
        background: rgba(45, 90, 39, 0.05);
        border: 1px solid rgba(45, 90, 39, 0.08);
        color: #2d5a27;
        text-decoration: none;

        &:hover {
          background: rgba(45, 90, 39, 0.12);
          border-color: rgba(45, 90, 39, 0.15);
          color: #2d5a27;
        }
      }

      &.header-download a {
        font-weight: 600;
      }
    }
  }
}

.lang-switcher {
  position: relative;
  display: flex;
  align-items: center;

  .lang-current {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 44px;
    min-height: 44px;
    box-sizing: border-box;
    cursor: pointer;
    padding: 0 20px;
    border-radius: 12px;
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    line-height: 1;
    font-weight: 500;
    transition: all 0.25s ease;
    background: rgba(45, 90, 39, 0.05);
    border: 1px solid rgba(45, 90, 39, 0.08);
    color: #2d5a27;

    &:hover {
      background: rgba(45, 90, 39, 0.12);
      border-color: rgba(45, 90, 39, 0.15);
    }
    
    .lang-arrow {
      transition: transform 0.25s ease;
      
      &.open {
        transform: rotate(180deg);
      }
    }
  }
  
  .lang-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 12px 40px rgba(45, 90, 39, 0.15);
    min-width: 160px;
    z-index: 10001;
    list-style: none;
    margin: 0;
    padding: 8px;
    border: 1px solid rgba(45, 90, 39, 0.08);
    animation: dropdownFade 0.2s ease;
    
    @keyframes dropdownFade {
      from {
        opacity: 0;
        transform: translateY(-8px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    li {
      a {
        display: block;
        padding: 12px 16px;
        color: #5a5a5a;
        text-decoration: none;
        font-family: 'DM Sans', sans-serif;
        font-size: 14px;
        border-radius: 10px;
        transition: all 0.2s ease;
        width: stretch;
        
        &:hover {
          background: rgba(45, 90, 39, 0.1);
          color: #2d5a27;
          padding-left: 20px;
        }
      }
    }
  }
}

.mods-switcher {
  position: relative;
  display: flex;
  align-items: center;

  .mods-current {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 44px;
    min-height: 44px;
    box-sizing: border-box;
    cursor: pointer;
    padding: 0 20px;
    border-radius: 12px;
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    line-height: 1;
    font-weight: 600;
    transition: all 0.25s ease;
    background: rgba(45, 90, 39, 0.05);
    border: 1px solid rgba(45, 90, 39, 0.08);
    color: #2d5a27;

    &:hover {
      background: rgba(45, 90, 39, 0.12);
      border-color: rgba(45, 90, 39, 0.15);
    }

    .mods-arrow {
      transition: transform 0.25s ease;

      &.open {
        transform: rotate(180deg);
      }
    }
  }

  .mods-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 12px 40px rgba(45, 90, 39, 0.15);
    min-width: 190px;
    z-index: 10001;
    list-style: none;
    margin: 0;
    padding: 8px;
    border: 1px solid rgba(45, 90, 39, 0.08);

    li {
      a {
        display: block;
        height: auto;
        min-height: 0;
        padding: 12px 16px;
        color: #5a5a5a;
        text-decoration: none;
        font-family: 'DM Sans', sans-serif;
        font-size: 14px;
        border-radius: 10px;
        transition: all 0.2s ease;
        background: transparent;
        border: 0;

        &:hover {
          background: rgba(45, 90, 39, 0.1);
          color: #2d5a27;
          padding-left: 20px;
        }
      }
    }
  }
}

.mods-switcher-mobile {
  .mods-current {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    color: #2c2c2c;
    border-radius: 12px;

    &:hover {
      background: rgba(45, 90, 39, 0.08);
    }
  }

  .mods-dropdown {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      a {
        display: block;
        padding: 12px 16px;
        color: #2c2c2c;
        text-decoration: none;
        font-family: 'DM Sans', sans-serif;
        font-size: 15px;
        text-align: center;
        border-radius: 10px;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(45, 90, 39, 0.1);
          color: #2d5a27;
        }
      }
    }
  }
}

.lang-switcher-mobile {
  .lang-current {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 14px;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    color: #2c2c2c;
    border-radius: 12px;
    
    &:hover {
      background: rgba(45, 90, 39, 0.08);
    }
  }
  
  .lang-dropdown {
    list-style: none;
    margin: 0;
    padding: 0;
    
    li {
      a {
        display: block;
        padding: 14px 16px;
        color: #2c2c2c;
        text-decoration: none;
        font-family: 'DM Sans', sans-serif;
        font-size: 15px;
        text-align: center;
        border-radius: 10px;
        transition: all 0.2s ease;
        
        &:hover {
          background: rgba(45, 90, 39, 0.1);
          color: #2d5a27;
        }
      }
    }
  }
}

.mobile-menu {
  .menu-toggle {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 12px;
    transition: all 0.25s ease;
    background: rgba(45, 90, 39, 0.05);
    
    &:hover {
      background: rgba(45, 90, 39, 0.12);
    }
    
    img {
      width: 24px;
      height: 24px;
    }
  }
}

/* 响应式 */
@media (max-width: 768px) {
  #site-navigation {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    .inside-navigation {
      --nav-inline-pad: 16px;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0;
      padding: 0 var(--nav-inline-pad);
      box-sizing: border-box;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
    }
  }

  .navigation-branding {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;

    .site-logo img {
      height: 36px;
    }

    .main-title {
      font-size: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .main-nav {
    flex: 0 0 auto;
  }
}

@media screen and (max-width: 768px) {
  /*
   * 父级 .inside-navigation 有 padding:0 16px，绝对定位子元素的 100% 宽是「内容区」宽度，
   * 下拉会从 padding 内侧开始，左侧会空出一条与 padding 等宽的缝。
   * 用 left/right 负偏移抵消两侧 padding，使白底与视口同宽。
   */
  .inside-navigation .mobile-menu-page {
    position: absolute;
    top: 100%;
    left: calc(-1 * var(--nav-inline-pad, 16px));
    right: calc(-1 * var(--nav-inline-pad, 16px));
    width: auto;
    z-index: 1001;
    margin: 0 !important;
    box-sizing: border-box;
    box-shadow: 0 12px 24px rgba(45, 90, 39, 0.12);
    border-radius: 0 0 14px 14px;
    overflow: hidden;

    .menu-item {
      padding: 14px 0;
      margin-bottom: 0 !important;
      background: #fff;

      a,
      div {
        font-size: 15px;
        text-align: center;
        color: #121212;
        display: block;
      }
    }
  }

  .main-nav {
    flex: 0 0 auto;
    margin-right: 0;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      position: relative;

      .menu-toggle {
        display: block;
        display: flex;
        justify-content: center;
        padding: 12px 12px;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
